import { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { FetchPolicy } from 'utils/enum/Core';
import NumberUtils from 'lib/NumberUtils';
import ModalUtils from 'utils/ModalUtils';
import { ReconStatus } from 'utils/enum/InventoryEnum';
import InventoryMutation from 'services/graphQL/mutate/InventoryMutation';

const useReconActions = () => {
    const client = useApolloClient();
    const [state, setState] = useState({
        savingReconStatus: false,
    });

    const {
        savingReconStatus,
    } = state;

    const changeReconStatus = async (
        stockNumber,
        nextStatus,
        ins = null,
        note,
        isApproving = false,
        totalEstimate,
        maximumReconCost,
        saveReconItemsCallback,
        isReapprovalRequest,
    ) => {
        if (
            isApproving
            && nextStatus === ReconStatus.INSPECTION_APPROVED
            && totalEstimate > maximumReconCost
        ) {
            ModalUtils.errorMessage(null, `The Max Recon Cost for this vehicle is ${NumberUtils.applyCurrencyFormat(maximumReconCost)}`);
            return null;
        }

        if ((note ?? '').length > 500) {
            ModalUtils.errorMessage(null, 'The general instructions cannot be greater than 500 characters');
            return null;
        }

        try {
            setState({ savingReconStatus: true });
            if (saveReconItemsCallback) await saveReconItemsCallback(false);

            const { data } = await client.mutate({
                mutation: InventoryMutation.SET_RECON_STATUS,
                variables: {
                    stockNumber,
                    status: nextStatus,
                    note,
                    inspector: ins,
                    reapproval: isReapprovalRequest,
                },
                fetchPolicy: FetchPolicy.NO_CACHE,
            });

            setState({ savingReconStatus: false });
            if (data) {
                return {
                    status: nextStatus,
                    inspector: ins,
                };
            }
        } catch (error) {
            ModalUtils.errorMessage(null, error.message);
            setState({ savingReconStatus: false });
        }

        return null;
    };

    return {
        changeReconStatus,
        savingReconStatus,
    };
};

export default useReconActions;
